import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ButtonBase from "@mui/material/ButtonBase";

// project import
import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";
import { APP_DEFAULT_PATH } from "config";
// import useAuth from "hooks/useAuth";

export default function LogoSection({ reverse, isIcon, sx, to }) {
  // const { isLoggedIn } = useAuth();

  return (
    <ButtonBase
      disableRipple
      {...{
        component: Link,
        to: !to ? "/dashboard" : to,
        sx,
      }}
    >
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = {
  reverse: PropTypes.bool,
  isIcon: PropTypes.bool,
  sx: PropTypes.any,
  to: PropTypes.any,
};
